<template>
  <div class="template-detail-container">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-left">
        <h2>发货单详情预览</h2>
        <p>使用真实数据预览发货单模板效果</p>
      </div>
      <div class="header-actions">
        <el-button @click="goBack">
          <i class="el-icon-back"></i>
          返回列表
        </el-button>
        <el-button type="primary" v-print="printOptions">
          <i class="el-icon-printer"></i>
          打印
        </el-button>
        <el-button type="success" @click="exportPdf">
          <i class="el-icon-download"></i>
          导出PDF
        </el-button>
      </div>
    </div>

    <!-- 详情内容 -->
    <div class="detail-content">
      <div class="detail-container" v-loading="loading">
        <!-- 使用 ref 标记打印区域 -->
        <div id="printArea" ref="printArea" class="detail-preview" :style="printAreaStyles">
          <!-- 使用结构化的DOM而不是v-html -->
          <div class="delivery-template">
            <!-- 表头区域 -->
            <div class="template-header" v-if="template && template.config && template.config.showSections.header">
              <div class="header-title" v-if="hasHeaderField('title')">
                {{ realData.info.title || '发货单' }}
              </div>
              <div class="header-info">
                <div v-for="field in visibleHeaderFields" :key="field.key" class="info-item" v-if="field.key !== 'title'">
                  <span class="field-label">{{ field.label }}:</span> {{ realData.info[field.key] || '' }}
                </div>
              </div>
            </div>

            <!-- 表格区域 -->
            <div class="table-container" v-if="template && template.config && template.config.showSections.table">
              <table class="goods-table">
                <thead>
                  <tr>
                    <th v-for="field in visibleTableFields" :key="field.key">{{ field.label }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in realData.list" :key="index">
                    <td v-for="field in visibleTableFields" :key="field.key">
                      <!-- 根据字段类型显示不同格式 -->
                      <template v-if="field.key === 'price' || field.key === 'amount'">
                        {{ item[field.key] ? item[field.key].toFixed(2) : '0.00' }}
                      </template>
                      <template v-else>
                        {{ item[field.key] || '' }}
                      </template>
                    </td>
                  </tr>
                </tbody>
                <tfoot v-if="template && template.config && template.config.showSections.tableFooter">
                  <tr>
                    <td :colspan="visibleTableFields.length - 1" class="text-right">合计:</td>
                    <td class="total-amount">{{ realData.info.totalAmount || '0.00' }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <!-- 表尾区域 -->
            <div class="template-footer" v-if="template && template.config && template.config.showSections.footer">
              <div class="footer-info">
                <div v-for="field in visibleFooterFields" :key="field.key" class="footer-item">
                  <span v-if="field.key === 'signature'">
                    <span class="field-label">{{ field.label }}:</span> ________________
                  </span>
                  <span v-else>
                    <span class="field-label">{{ field.label }}:</span> {{ realData.info[field.key] || '' }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TemplateDetail',
  data() {
    return {
      templateId: '',
      template: null,
      loading: true,
      
      // 打印配置选项
      printOptions: {
        id: 'printArea',
        popTitle: '发货单打印',
        extraHead: '<meta charset="utf-8" />',
        extraCss: '',
        beforeOpenCallback() {
          console.log('打印窗口即将打开')
        },
        openCallback() {
          console.log('打印窗口已打开')
        },
        closeCallback() {
          console.log('打印窗口已关闭')
        }
      },
      
      // 模拟的真实数据
      realData: {
        info: {
          title: '发货单',
          companyName: '江西壹号农业科技有限公司',
          customerName: '南昌市红谷滩区鲜果超市',
          deliveryDate: '2024-05-20',
          orderNo: 'SO202405200001',
          address: '江西省南昌市红谷滩区绿地中央广场A座1201',
          contact: '王经理',
          phone: '13912345678',
          totalAmount: '1,280.50',
          deliveryCompany: '江西壹号农业科技有限公司',
          deliveryPerson: '张师傅',
          deliveryTime: '2024-05-20 09:30',
          remark: '请在上午10点前送达，注意保持水果新鲜'
        },
        list: [
          { index: 1, goodsName: '红富士苹果', specification: '特级', unit: '箱', quantity: 5, price: 120, amount: 600, remark: '每箱10斤' },
          { index: 2, goodsName: '泰国香蕉', specification: '一级', unit: '箱', quantity: 3, price: 80, amount: 240, remark: '每箱8斤' },
          { index: 3, goodsName: '海南菠萝', specification: '特级', unit: '箱', quantity: 2, price: 90, amount: 180, remark: '每箱2个' },
          { index: 4, goodsName: '智利车厘子', specification: 'JJ级', unit: '盒', quantity: 4, price: 65, amount: 260, remark: '每盒500g' },
          { index: 5, goodsName: '泰国山竹', specification: '特级', unit: '箱', quantity: 1, price: 150, amount: 150, remark: '每箱5斤' }
        ]
      }
    }
  },
  
  computed: {
    // 可见的表头字段
    visibleHeaderFields() {
      if (!this.template || !this.template.config || !this.template.config.headerFields) {
        return []
      }
      return this.template.config.headerFields.filter(field => field.show)
    },
    
    // 可见的表格字段
    visibleTableFields() {
      if (!this.template || !this.template.config || !this.template.config.tableFields) {
        return []
      }
      return this.template.config.tableFields.filter(field => field.show)
    },
    
    // 可见的表尾字段
    visibleFooterFields() {
      if (!this.template || !this.template.config || !this.template.config.footerFields) {
        return []
      }
      return this.template.config.footerFields.filter(field => field.show)
    },
    
    // 打印区域样式
    printAreaStyles() {
      if (!this.template || !this.template.config || !this.template.config.styleConfig) {
        return {}
      }
      
      const { paperSize, orientation, fontSize } = this.template.config.styleConfig
      
      return {
        fontSize: `${fontSize || 12}px`,
        width: orientation === 'landscape' ? 
          (paperSize === 'A4' ? '297mm' : '210mm') : 
          (paperSize === 'A4' ? '210mm' : '148mm'),
        minHeight: orientation === 'landscape' ? 
          (paperSize === 'A4' ? '210mm' : '148mm') : 
          (paperSize === 'A4' ? '297mm' : '210mm'),
        margin: '0 auto'
      }
    }
  },
  
  created() {
    this.templateId = this.$route.query.templateId
    this.loadTemplate()
  },
  
  mounted() {
    this.setPrintStyles()
  },
  
  methods: {
    // 检查是否有特定的表头字段
    hasHeaderField(key) {
      if (!this.visibleHeaderFields || this.visibleHeaderFields.length === 0) {
        return false
      }
      return this.visibleHeaderFields.some(field => field.key === key)
    },
    
    // 导出PDF - 使用html2canvas
    async exportPdf() {
      try {
        this.$message.info('正在生成PDF，请稍候...');
        
        // 动态导入html2canvas和jspdf
        const html2canvas = (await import('html2canvas')).default;
        const jsPDF = (await import('jspdf')).jsPDF;
        
        const printArea = this.$refs.printArea;
        
        // 临时设置样式以优化截图效果
        const originalStyle = printArea.style.cssText;
        printArea.style.cssText = `
          ${originalStyle}
          background: white;
          padding: 20px;
          width: 794px;
          min-height: auto;
          transform: scale(1);
          transform-origin: top left;
        `;
        
        // 使用html2canvas截图
        const canvas = await html2canvas(printArea, {
          scale: 2,
          useCORS: true,
          allowTaint: true,
          backgroundColor: '#ffffff',
          width: 794,
          height: null,
          scrollX: 0,
          scrollY: 0,
          windowWidth: 1200,
          windowHeight: 800
        });
        
        // 恢复原始样式
        printArea.style.cssText = originalStyle;
        
        // 创建PDF
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        
        // 计算图片在PDF中的尺寸
        const pdfWidth = 210;
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
        
        // 如果内容高度超过A4纸高度，需要分页
        const pageHeight = 297;
        let heightLeft = pdfHeight;
        let position = 0;
        
        // 添加第一页
        pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
        heightLeft -= pageHeight;
        
        // 如果需要分页
        while (heightLeft >= 0) {
          position = heightLeft - pdfHeight;
          pdf.addPage();
          pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
          heightLeft -= pageHeight;
        }
        
        // 下载PDF
        const fileName = `${this.template ? this.template.name : '发货单'}_${new Date().getTime()}.pdf`;
        pdf.save(fileName);
        
        this.$message.success('PDF导出成功');
      } catch (error) {
        console.error('PDF导出失败:', error);
        this.$message.error('PDF导出失败，请重试');
      }
    },
    
    // 加载模板
    loadTemplate() {
      this.loading = true
      
      // 从本地存储获取模板
      const templates = JSON.parse(localStorage.getItem('deliveryTemplates') || '[]')
      this.template = templates.find(t => t.id === this.templateId)
      
      if (!this.template) {
        this.$message.error('模板不存在')
        this.goBack()
        return
      }
      
      // 加载完模板后设置打印样式
      this.$nextTick(() => {
        this.setPrintStyles()
      })
      
      this.loading = false
    },
    
    // 返回列表页
    goBack() {
      this.$router.push('/delivery/template-list')
    },
    
    // 设置打印样式
    setPrintStyles() {
      // 获取模板样式配置
      const styleConfig = this.template && this.template.config ? this.template.config.styleConfig || {} : {};
      const { paperSize = 'A4', orientation = 'portrait', fontSize = 12 } = styleConfig;
      
      // 设置打印CSS
      this.printOptions.extraCss = `
        @page {
          size: ${paperSize} ${orientation};
          margin: 10mm;
        }
        @media print {
          html, body {
            margin: 0 !important;
            padding: 0 !important;
            height: auto !important;
            overflow: visible !important;
            font-family: SimSun, serif;
            font-size: ${Math.max(fontSize, 10)}px;
            line-height: 1.3;
            background: white !important;
          }
          
          * {
            box-sizing: border-box !important;
            margin: 0 !important;
            padding: 0 !important;
            border: none !important;
            outline: none !important;
            box-shadow: none !important;
          }
          
          #printArea {
            width: 100% !important;
            height: auto !important;
            padding: 5mm !important;
            margin: 0 !important;
            overflow: visible !important;
            background: white !important;
          }
          
          .delivery-template {
            width: 100% !important;
            height: auto !important;
            padding: 0 !important;
            margin: 0 !important;
            overflow: visible !important;
            page-break-after: avoid !important;
            page-break-inside: avoid !important;
          }
          
          .template-header {
            text-align: center !important;
            margin-bottom: 8px !important;
          }
          
          .header-title {
            font-size: ${Math.max(fontSize + 4, 16)}px !important;
            font-weight: bold !important;
            margin-bottom: 6px !important;
            line-height: 1.2 !important;
          }
          
          .header-info {
            display: flex !important;
            flex-wrap: wrap !important;
            justify-content: space-between !important;
            margin-bottom: 8px !important;
          }
          
          .info-item {
            width: 48% !important;
            margin-bottom: 2px !important;
            display: flex !important;
            font-size: ${Math.max(fontSize - 1, 9)}px !important;
            line-height: 1.2 !important;
          }
          
          .field-label {
            font-weight: bold !important;
            margin-right: 5px !important;
            min-width: 70px !important;
          }
          
          .table-container {
            margin: 8px 0 !important;
          }
          
          table {
            width: 100% !important;
            border-collapse: collapse !important;
            border-spacing: 0 !important;
            margin: 0 !important;
            page-break-inside: avoid !important;
          }
          
          table th, table td {
            border: 1px solid #000 !important;
            padding: 3px 4px !important;
            text-align: center !important;
            font-size: ${Math.max(fontSize - 1, 9)}px !important;
            line-height: 1.2 !important;
            vertical-align: middle !important;
          }
          
          table th {
            background-color: #f5f5f5 !important;
            font-weight: bold !important;
          }
          
          .text-right {
            text-align: right !important;
          }
          
          .total-amount {
            font-weight: bold !important;
          }
          
          .template-footer {
            margin-top: 8px !important;
          }
          
          .footer-info {
            display: flex !important;
            flex-wrap: wrap !important;
            justify-content: space-between !important;
          }
          
          .footer-item {
            width: 48% !important;
            margin-bottom: 2px !important;
            display: flex !important;
            font-size: ${Math.max(fontSize - 1, 9)}px !important;
            line-height: 1.2 !important;
          }
          
          .delivery-template {
            max-height: calc(297mm - 20mm) !important;
            overflow: hidden !important;
          }
          
          .template-detail-container,
          .page-header,
          .detail-content,
          .detail-container,
          .detail-preview {
            display: none !important;
          }
          
          #printArea {
            display: block !important;
          }
        }
      `;
    }
  }
}
</script>

<style scoped>
.template-detail-container {
  padding: 20px;
  background: #f5f5f5;
  min-height: 100vh;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.header-left h2 {
  margin: 0 0 8px 0;
  color: #333;
  font-size: 24px;
}

.header-left p {
  margin: 0;
  color: #666;
  font-size: 14px;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.detail-content {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  padding: 20px;
}

.detail-container {
  min-height: 500px;
}

.detail-preview {
  padding: 10px;
  border: 1px solid #eee;
  background: white;
  max-height: 800px;
  overflow-y: auto;
}

.table-container {
  width: 100%;
  overflow-x: auto;
  margin: 20px 0;
}

@media print {
  .detail-preview {
    max-height: none;
    overflow: visible;
  }
  
  .table-container {
    overflow: visible;
  }
  
  html, body {
    height: auto !important;
    overflow: hidden !important;
  }
}

.delivery-template {
  font-family: SimSun, serif;
  font-size: 12px;
}

.template-header {
  text-align: center;
  margin-bottom: 10px;
}

.header-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.header-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  text-align: left;
}

.info-item {
  padding: 5px 0;
  display: flex;
  margin-bottom: 8px;
}

.field-label {
  font-weight: bold;
  margin-right: 5px;
  min-width: 80px;
  text-align: right;
  color: #333;
}

.goods-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
  min-width: 800px;
}

.goods-table th,
.goods-table td {
  border: 1px solid #333;
  padding: 2px 4px;
  text-align: center;
  word-break: break-word;
  min-width: 50px;
}

.goods-table th {
  background-color: #f5f5f5;
  font-weight: bold;
  height: 24px;
}

.goods-table td {
  height: 22px;
}

.text-right {
  text-align: right;
}

.total-amount {
  font-weight: bold;
}

.template-footer {
  margin-top: 15px;
}

.footer-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.footer-item {
  padding: 5px 0;
  display: flex;
}

@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    gap: 16px;
  }
  
  .header-actions {
    align-self: stretch;
  }
  
  .header-info,
  .footer-info {
    grid-template-columns: 1fr;
  }
}
</style>